import { Stack, StackProps } from "@chakra-ui/react"

export const Section = (props: StackProps) => {
  return (
    <Stack
      w="100%"
      pl={{ base: 4, md: 10 }}
      pr={{ base: 4, md: 10 }}
      pt={5}
      pb={10}
      gap={0}
      {...props}
    />
  )
}